import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {
  bookcaseMap,
  bookcoverOnShelf,
  bookshelfinfo,
  bookshelfpoint,
  itembookshelfinfo,
} from '../models/modelVirtualbook';
import {
  book856,
  callNoResponse,
  category,
  EducationalResources,
  FriendModel,
  HoldingAvailableIssues,
  keywordModel,
  locationCollectionResponse,
  returnCategorySubCategory,
  returnSubCategory,
  SearchTool,
  TagCloudModel,
} from '../models/walai';
import { catchError } from 'rxjs/operators';
import { ApiConfig, ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  
  private _apiconfig: ApiConfig;
  private apiUrl = '';
  private token = '';
  
  // private baseUrl = '';
  // header = new HttpHeaders();

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
  ) {
    this._apiconfig =  this.configService.apiConfig;
    this.apiUrl = this._apiconfig.url;
    this.token = this._apiconfig.token;
   // console.log('apiUrl', this._apiconfig);
    // this.header.append('Content-Type', 'application/json');
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      //authorization: ''
    }),
  };


  private handleError(err: HttpErrorResponse): Observable<never> {
    return throwError(() => err);
  }

   // getBlockNotice(USERID: any) {
  //   throw new Error('Method not implemented.');
  // }


  getLocation() {
    return this.http.get<any[]>(`${this.apiUrl}/api/Location`, this.httpOptions);
  }

  getLocationName(id) {
    return this.http.get<string>(`${this.apiUrl}/api/GetLocationName/${id}`, this.httpOptions);
  }

  getTop(id): Observable<any> {
    return this.http.get<any[]>(`${this.apiUrl}/api/SuggestBook/${id}`, this.httpOptions);
  }

  //   function tryLogin(...put here your args): Observable<any> {
  //     return this.webService.isTokenValid(jsonStr);
  //     // Yep, just this. Usually services don't handle logic.
  //  }

  async getBibInfo(id) {
   // this.baseUrl = `${environment.apiurl}/api/BookInfo/${id}`;
    const response = await this.http.get<any[]>(`${this.apiUrl}/api/BookInfo/${id}`, this.httpOptions);
    return response;
  }

  // getBibInfo(id) {
  //   this.baseUrl = `${environment.apiurl}/api/BookInfo/${id}`;
  //   return this.http.get<any[]>(this.baseUrl, httpOptions);
  // }

  //   getItems(id){
  //   this.baseUrl = `${environment.apiurl}/api/GetItems/${id}`;
  //   const response =   this.http.get<any[]>(this.baseUrl, httpOptions);
  //   return   response;
  // }

  getItems(id): Observable<any> {
    return this.http
      .get<any>(`${this.apiUrl}/api/GetItems/${id}`, {
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  /*สำหรับเช็คว่ามีข้อมูลของรายการ map (virtual bookshelf)*/
  async getItemShowmap(id) {
    const response = await this.http.get<any[]>(`${this.apiUrl}/api/GetItem/${id}`, this.httpOptions);
    return response;
  }

  getBookRelated(id, num): Observable<any> {
    return this.http.get<any[]>(`${this.apiUrl}/api/GetBookRelated/${id}/${num}`, this.httpOptions);
  }

  getAllTitleInIssue(id): Observable<any> {
    return this.http.get<any[]>(`${this.apiUrl}/api/GetAllTitleInIssue/${id}`, this.httpOptions);
  }

  

  getBookStatic(id): Observable<any> {
    return this.http.get<any[]>(`${this.apiUrl}/api/BibStatic/${id}`, this.httpOptions);
  }

  getBookNewMatType(id) {
    return this.http.get<String>(`${this.apiUrl}/api/GetBookNewMatType/${id}`, this.httpOptions);
  }

  getBook856(id): Observable<any> {
    return this.http.get<book856[]>(`${this.apiUrl}/api/GetBook856/${id}`, this.httpOptions);
  }

  getMARC(id): Observable<any> {
    return this.http.get<any[]>(`${this.apiUrl}/api/MARC/${id}`, this.httpOptions);
  }

  getItemStatus(id): Observable<any> {
    return this.http.get<any[]>(`${this.apiUrl}/api/GetItemStatus/${id}`, this.httpOptions);
  }

  getParameter(PARAMETERKEY): Observable<any> {
    return this.http.get<any[]>(`${this.apiUrl}/api/GetOPACConfig/${PARAMETERKEY}`, this.httpOptions);
  }

  public getParameterPipe(PARAMETERKEY): Observable<any> {
    return this.http
      .get<any>(`${this.apiUrl}/api/GetOPACConfig/${PARAMETERKEY}`, 
        { observe: 'response' })
      .pipe(catchError(this.handleError));
  }

  getLang(): Observable<any> {
    return this.http.get<any[]>(`${this.apiUrl}/api/GetLang/`, this.httpOptions);
  }

  getMaterialType(): Observable<any> {
    return this.http.get<any[]>(`${this.apiUrl}/api/MaterialType/`, this.httpOptions);
  }

  getCallNumber(): Observable<callNoResponse> {
    return this.http.get<callNoResponse>(`${this.apiUrl}/api/GetCallNumber/`, this.httpOptions);
  }

  getCollection(): Observable<locationCollectionResponse[]> {
    return this.http.get<locationCollectionResponse[]>(`${this.apiUrl}/api/GetCollection/`, this.httpOptions
    );
  }

  getCatagory(): Observable<category[]> {
    return this.http.get<category[]>(`${this.apiUrl}/api/getCatagory/`, this.httpOptions);
  }

  getSubCatagory(id): Observable<returnCategorySubCategory> {
    return this.http.get<returnCategorySubCategory>(`${this.apiUrl}/api/getSubCatagory/${id}`, this.httpOptions);
  }

  getSubject(id): Observable<returnSubCategory> {
    return this.http.get<returnSubCategory>(`${this.apiUrl}/api/getSubject/${id}`, this.httpOptions);
  }

  checkSerial(id): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiUrl}/api/checkSerial/${id}`, this.httpOptions);
  }

  getMarcHolding(id): Observable<any> {
    return this.http.get<any[]>(`${this.apiUrl}/api/getMarcHolding/${id}`, this.httpOptions);
  }

  getHolding(id): Observable<any> {
    return this.http.get<any[]>( `${this.apiUrl}/api/getHolding/${id}`, this.httpOptions);
  }

  getSerialItemForOPAC(id): Observable<HoldingAvailableIssues[]> {
    return this.http.get<HoldingAvailableIssues[]>(`${this.apiUrl}/api/GetSerialItemForOPAC/${id}`, 
      this.httpOptions);
  }

  getBookCoverAll(id): Observable<any> {
    return this.http.get<any[]>(`${this.apiUrl}/api/getBookCoverAll/${id}`, this.httpOptions);
  }

  /*virtual  bookshelf */
  getbookshelfinfo(id): Observable<bookshelfinfo[]> {
    //แสดงข้อมูล shelf
    return this.http.get<bookshelfinfo[]>( `${this.apiUrl}/api/ShowBookShelfInfo/${id}`, this.httpOptions);
  }

  showbookcasemap(id): Observable<bookcaseMap[]> {
    //แสดงตำแหน่งตู้บน map
    return this.http.get<bookcaseMap[]>(`${this.apiUrl}/api/ShowBookCaseMap/${id}`, this.httpOptions);
  }

  showbookshelfpoint(id): Observable<bookshelfpoint> {
    //แสดงตำแหน่งชั้นหนังสือบนตู้
    return this.http.get<bookshelfpoint>(`${this.apiUrl}/api/ShowBookShelfPoint/${id}`, this.httpOptions);
  }

  showiteminfo(id): Observable<itembookshelfinfo[]> {
    //แสดงข้อมูล item
    return this.http.get<itembookshelfinfo[]>(`${this.apiUrl}/api/ShowItemInfo/${id}`, this.httpOptions);
  }

  showbookcovers(id): Observable<bookcoverOnShelf[]> {
    //แสดงข้อมูลปก bib (vb)
    return this.http.get<bookcoverOnShelf[]>(`${this.apiUrl}/api/showBookCovers/${id}`, this.httpOptions);
  }

  bookcover(id): Observable<any> {
    //แสดงรูปปก bib
    return this.http.get<any>(`${this.apiUrl}/api/BookCover/${id}`, this.httpOptions);
  }

  getpinitem(id): Observable<any> {
    //pin item
    return this.http.get<any>(`${this.apiUrl}/api/PinItem/${id}`, this.httpOptions);
  }

  pinitem(id, barcode): Observable<any> {
    //pin item
    return this.http.post<any>(`${this.apiUrl}/api/PinItem?userid=${id}&barcode=${barcode}`, this.httpOptions);
  }

  getBookCoverPath(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/api/BookCoverURL`, this.httpOptions);
  }

  public getBookReviewLibrarain(bibid: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.apiUrl}/api/bookReviewLibrarain/${bibid}`, this.httpOptions);
  }

  public getBookReviewMember(bibid: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.apiUrl}/api/bookReviewMember/${bibid}`,this.httpOptions );
  }

  getgenDublinCoreMetadata(bibid: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.apiUrl}/api/DublinCoreMetadata/${bibid}`,this.httpOptions);
  }

  async bibExportList(idList, type): Promise<Observable<any>> {
    return await this.http.get<any[]>(`${this.apiUrl}/api/ExportList/${idList}/${type}`, this.httpOptions);
  }

  async bibExportList2(idList, type): Promise<Observable<any>> {
    let objBiblist:bib_list={
      value: idList
    }
   // return await this.http.get<any[]>(this.baseUrl, httpOptions);
    return this.http.post<any[]>(`${this.apiUrl}/api/ExportList2/${type}`,  objBiblist, this.httpOptions);
  }


  bibExport(id, type): Observable<any> {
    return this.http.get<any[]>(`${this.apiUrl}/api/Export/${id}/${type}`, this.httpOptions);
  }

  getFilePath(type: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/api/getFilesURL/${type}`, this.httpOptions);
  }

  getEducationalResources(): Observable<EducationalResources[]> {
    return this.http.get<any>(`${this.apiUrl}/api/EducationalResources`, this.httpOptions);
  }

  getSearchTool(): Observable<SearchTool[]> {
    return this.http.get<any>(`${this.apiUrl}/api/SearchTool`, this.httpOptions);
  }

  /**Resource delivery */

  CheckOpenRD(): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiUrl}/api/CheckOpenRD`, this.httpOptions);
  }

  public GetNDDFee(type: string, page: number): Observable<any> {
    return this.http
      .get<any>(`${this.apiUrl}/api/` + type + '/' + page, {
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  getNDDRequestTypeOpen(itemId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/api/NDDrequestTypeOpen/${itemId}`, this.httpOptions);
  }

  GetNDDTypeOpen(id: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/api/NDDTypeOpen/${id}`, this.httpOptions);
  }


  getJMarcPage(marcId: string): Observable<any> {

    //return this.http.get<any[]>(this.baseUrl, httpOptions);
    return this.http.get<any>(`${this.apiUrl}/api/getJMarcPage/${marcId}`,{
      observe: 'response',
    })
    .pipe(catchError(this.handleError));
  }


  public NDDCheckPageformat(page: number): Observable<any> {
    return this.http
      .get<any>(`${this.apiUrl}/api/NDDCheckPageformat?page=${page}`, {
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  addOpacview(val: any) {
    return this.http.post<any>(`${this.apiUrl}/api/opacview`, val, this.httpOptions);
  }

  public checkWALAICOVER(isbn: string): Observable<any> {
      return this.http.get<any>(`https://opac-api.wu.ac.th/synccoverbook/v1/api/GetBookCover/${isbn}`, 
        this.httpOptions);
  }


  getTagCloud(id): Observable<any> {
    return this.http.get<TagCloudModel[]>(`${this.apiUrl}/api/GenTagByBIBID/${id}`, this.httpOptions);
  }

  GetUserTagInBibItem(userid): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/api/GetUserTagInBibItem/${userid}`, this.httpOptions);
  }

  getTagCloudAll(): Observable<any> {
    return this.http.get<TagCloudModel[]>(`${this.apiUrl}/api/GetTagAll`, this.httpOptions);
  }

  GetMemberByKeyword(keyword:keywordModel): Observable<FriendModel[]> {
    return this.http.post<FriendModel[]>(`${this.apiUrl}/api/GetMemberByKeyword`, keyword, 
      this.httpOptions);
  }

}


export class bib_list {
  public value: string;
}